<template>
  <b-card class="border border-secondary">
    <div class="card">
      <b-row>
        <b-col md="6">
          <div class="form-label-group">
            <b-form-input
              id="floating-label1"
              placeholder="Elektrik"
              type="number"
            />
            <label for="floating-label1">kWh Cinsinden</label>
          </div>
          <div class="form-label-group">
            <b-form-input
              id="floating-label1"
              type="float"
              placeholder="Doğalgaz"
            />
            <label for="floating-label1">
              m^3 Cinsinden
            </label>
          </div>
          <div class="form-label-group">
            <b-form-input
              id="floating-label1"
              placeholder="Akaryakıt"
              type="number"
            />
            <label for="floating-label1">Ton Cinsinden</label>
          </div>
        </b-col>
        <b-col md="6">
          <div class="form-label-group has-icon-left">
            <b-form-input
              id="iconLabelLeft"
              placeholder="TEP"
              disabled
            />
            <div class="form-control-position">
              <i class="bx bx-user" />
            </div>
            <label for="iconLabelLeft">Icon Left, Default Input</label>
          </div>
          <div class="form-label-group has-icon-left">
            <b-form-input
              id="iconLabelLeft"
              placeholder="TEP"
              disabled
            />
            <div class="form-control-position">
              <i class="bx bx-user" />
            </div>
            <label for="iconLabelLeft">Icon Left, Default Input</label>
          </div>
          <div class="form-label-group has-icon-left">
            <b-form-input
              id="iconLabelLeft"
              placeholder="TEP"
              disabled
            />
            <div class="form-control-position">
              <i class="bx bx-user" />
            </div>
            <label for="iconLabelLeft">Icon Left, Default Input</label>
          </div>
        </b-col>

      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BFormInput, BRow, BCol, BCard,
} from 'bootstrap-vue'

export default {
  components: {

    BFormInput,
    BRow,
    BCol,
    BCard,
  },
}
</script>
